import * as React from 'react';
import { Component } from 'react';
import { StickyPhone } from '@components/StickyPhone/StickyPhone';
import Measure from 'react-measure';
import { ExplainLeft, ExplainRight, VerticalSpace } from './SectionPhone.s';
import { Heading, HeadingRight, Paragraph } from '@components/Typos/Typos.s';
import { SectionContent } from '@components/Sections/Sections.s';
import { mobileBreakpoint } from '@styles/layout';

type SectionPhoneState = {
  stickyStart: number;
  stickyEnd: number;
};

type SectionPhoneProps = {
  innerRef?: (el: HTMLElement) => void;
  windowHeight: number;
  windowWidth: number;
};

export class SectionPhone extends Component<SectionPhoneProps, SectionPhoneState> {
  constructor(props: SectionPhoneProps) {
    super(props);

    this.state = {
      stickyStart: 2000,
      stickyEnd: 3000,
    };
  }

  render(): JSX.Element {
    return (
      <Measure
        offset={true}
        onResize={({ offset }) => {
          if (offset) {
            this.setState({ stickyStart: offset.top, stickyEnd: offset.top + offset.height });
          }
        }}
      >
        {({ measureRef }) => (
          <SectionContent
            innerRef={(el: HTMLElement) => {
              measureRef(el);
              if (this.props.innerRef) {
                this.props.innerRef(el);
              }
            }}
          >
            {this.props.windowWidth >= mobileBreakpoint ? (
              <StickyPhone
                start={this.state.stickyStart + 100}
                end={this.state.stickyEnd - 100}
                windowHeight={this.props.windowHeight}
              />
            ) : null}
            <ExplainRight>
              <Heading>Trouve une expo en fonction de ton mood !</Heading>
              <Paragraph>
                Qui est ton modèle ? Quel voyage est fait pour toi ? Qui est ton chanteur préféré ? Réponds à quelques
                questions et on va te trouver l’exposition faite pour toi pour ce week-end !
              </Paragraph>
            </ExplainRight>
            <VerticalSpace size={400} />
            <ExplainLeft>
              <HeadingRight>Elles sont faites pour&nbsp;toi</HeadingRight>
              <Paragraph>
                Découvre un maximum d’expositions qui te correspondent et prépare ta liste de « must see » en un rien
                de&nbsp;temps.
              </Paragraph>
            </ExplainLeft>
            <VerticalSpace size={400} />
            <ExplainRight>
              <Heading>Toutes les infos sont dans ta poche !</Heading>
              <Paragraph>
                Garde un oeil sur les activités de tes amis pour ne rien rater ! Julie est aussi intéressée par la
                prochaine exposition sur Picasso ? Une autre raison de plus pour y aller&nbsp;!
              </Paragraph>
            </ExplainRight>
          </SectionContent>
        )}
      </Measure>
    );
  }
}



// WEBPACK FOOTER //
// src/app/src/components/SectionPhone/SectionPhone.tsx